/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		this.parent = this.closest('.product-recommendations--parent');

	}
	fetchProducts() {
		fetch(this.dataset.url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('product-recommendations');

				if (recommendations && recommendations.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;

					this.initComplementarySlider();

					if ( this.parent ) {
						this.parent.classList.add('product-recommendations--full');

						if ( document.body.classList.contains('open-cart')) {
							this.parent.classList.add('active');
						}
					}

				}

				this.classList.add('product-recommendations--loaded');

			})
			.catch(() => {});
	}
	initComplementarySlider() {
		// Fetched HTML is injected after DOM ready, so Flickity's declarative
		// data-flickity init never runs on it — init by hand.
		const track = this.querySelector('[data-complementary-slider]');

		if (!track || typeof Flickity === 'undefined') {
			return;
		}

		const flkty = new Flickity(track, {
			freeScroll: true,
			contain: true,
			groupCells: false,
			cellAlign: 'left',
			pageDots: false,
			prevNextButtons: false
		});

		const prev = this.querySelector('.flickity-prev');
		const next = this.querySelector('.flickity-next');
		const activate = (el, action) => {
			if (!el) {
				return;
			}
			el.addEventListener('click', action);
			el.addEventListener('keydown', (evt) => {
				if (evt.key === 'Enter' || evt.key === ' ') {
					evt.preventDefault();
					action();
				}
			});
		};

		activate(prev, () => flkty.previous(true, false));
		activate(next, () => flkty.next(true, false));
	}
	connectedCallback() {
		this.fetchProducts();
	}
}

customElements.define('product-recommendations', ProductRecommendations);
